import angular from "angular";

import {
  Calculation,
  InvoicesLogic,
  PayrollDetails,
  SalaryDateKind,
  Brand
} from "@salaxy/core";

import { EditDialogKnownActions, UiHelpers } from "../../services";

/**
 * Contains functionality for switching between salary date kinds for payrolls or calculations.
 */
export class SalaryDateKindController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["UiHelpers"];

  /**
   * The current business item that is being paid: Either Calculation or PayrollDetails.
   */
  public model: Calculation | PayrollDetails;

 /**
  * Function that is called when the salary date kind has been chagned
  * Function has the following locals:
  * paymentChannel: the selected payment channel.
  * businessObject: the current business object which has been changed.
  */
  public onSalaryDateKindChange: (params: {
    /** Selected payment channel */
    salaryDateKind: SalaryDateKind,
    /** The current business object which has been changed.  */
    businessObject: Calculation | PayrollDetails,
  }) => void;

  public salaryDateKinds = SalaryDateKindController.getSalaryDateKinds();

  constructor(private uiHelpers: UiHelpers) {
  }

  /**
   * Initializes the controller
   */
  public $onInit() {
    // Init here
  }

  /** Gets the current salary date kind object. */
  public get currentSalaryDateKind() {
    let currentValue: SalaryDateKind = undefined;
    if (InvoicesLogic.isCalculation(this.model)) {
      currentValue = this.model.workflow.salaryDateKind;
    } else if (InvoicesLogic.isPayroll(this.model)) {
      currentValue = this.model.input.salaryDateKind;
    }
    return this.salaryDateKinds.find((x) => x.value == currentValue) ?? this.salaryDateKinds[0];
  }


  /** Sets the salary date kind and starts recalculation. */
  public setSalaryDateKind(newSalaryDateKind: SalaryDateKind) {
    if (InvoicesLogic.isCalculation(this.model)) {
      this.showCalculationSalaryDateKindSelection(newSalaryDateKind, this.model);
    } else if (InvoicesLogic.isPayroll(this.model)) {
      this.showPayrollSalaryDateKindSelection(newSalaryDateKind, this.model);
    } else {
      throw new Error("Unknwon business object type.");
    }
  }



  /** Shows the salary date kind dialog */
  private showCalculationSalaryDateKindSelection(newSalaryDateKind: SalaryDateKind, calculation: Calculation) {
    const original = calculation.workflow.salaryDateKind;
    const isCfa = InvoicesLogic.isCfa(calculation.info.paymentChannel);
    const logic = {
        value: newSalaryDateKind,
        text: `SALAXY.ENUM.SalaryDateKind.${newSalaryDateKind}.label`,
        title: `SALAXY.ENUM.SalaryDateKind.${newSalaryDateKind}.description${isCfa ? "Cfa" : "NonCfa"}`
    };

    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/SalaryDateKind.html", calculation.workflow.salaryDateKind, logic).then( (result) => {
      if (result.action ==  EditDialogKnownActions.Ok) {
        if (original != newSalaryDateKind) {
          calculation.workflow.salaryDateKind = newSalaryDateKind;
          this.onSalaryDateKindChange({ salaryDateKind: newSalaryDateKind, businessObject: calculation });
        }
      }
    });
  }

  /** Shows the salary date kind dialog */
  private showPayrollSalaryDateKindSelection(newSalaryDateKind: SalaryDateKind, payroll: PayrollDetails) {

    const original = payroll.input.salaryDateKind;
    const isCfa = InvoicesLogic.isCfa(payroll.input.paymentChannel);
    const logic = {
        value: newSalaryDateKind,
        text: `SALAXY.ENUM.SalaryDateKind.${newSalaryDateKind}.label`,
        title: `SALAXY.ENUM.SalaryDateKind.${newSalaryDateKind}.description${isCfa ? "Cfa" : "NonCfa"}`
    };

    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/SalaryDateKind.html", payroll.input.salaryDateKind, logic).then( (result) => {
      if (result.action ==  EditDialogKnownActions.Ok) {
        if (original != newSalaryDateKind) {
          payroll.input.salaryDateKind = newSalaryDateKind;
          this.onSalaryDateKindChange({ salaryDateKind: newSalaryDateKind, businessObject: payroll });
        }
      }
    });
  }

  private static getSalaryDateKinds() {
    return [
      {
        value : SalaryDateKind.Default,
        text: "SALAXY.ENUM.SalaryDateKind.default.label",
        avatar: {
          color: Brand.getBrandColor("primary", "rgba"),
          icon: "bi-clock",
        }
      },
      {
        value : SalaryDateKind.InPast,
        text: "SALAXY.ENUM.SalaryDateKind.inPast.label",
        avatar: {
          color: Brand.getBrandColor("danger", "rgba"),
          icon: "bi-clock-history",
        }
      },
    ];
  }
}
